import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../App/API/api";


export const featchSearchActivity = createAsyncThunk(
    'activity/search',
    async ({ perPage = 6, search }, { rejectWithValue }) => {
        try {

            const response = await api.get('/search', {
                params: {
                    perPage: perPage,
                    search: search
                }
            });
            console.log(response.data)
            const data = {data:response.data.data,total:response.data.total};
            return data;
        } catch (error) {
            rejectWithValue(error);
            console.log("error : ",error)
            return error;
        }

    }
)

export const fetchSearchActivitySlice = createSlice({
    name: "searchActivity",
    initialState: {
        loading: false,
        error: null,
        activities: [],
        total:0
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(featchSearchActivity.pending, (state) => {
            state.loading = true;
            state.error = null;

        })
            .addCase(featchSearchActivity.fulfilled, (state, action) => {
                state.loading = false;

                state.activities = action.payload.data;
                state.total = action.payload.total;
            })
            .addCase(featchSearchActivity.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.total=0;
            })
    }
});


export default fetchSearchActivitySlice.reducer;
